import AdvisorAssistanceContainer from './AdvisorAssistanceContainer';

export default AdvisorAssistanceContainer;



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/SpeakToAdvisorPage/AdvisorAssistance/index.js